export default __webpack_public_path__ + "static/default-6f4dded6fe7eb19fba86c1bdfd0cc119.png";